module.exports = __webpack_public_path__ + "static/media/blogNVPHA.cdee9d7d.webp";